import React from 'react';
import CommonInvoiceAdd from '../../../components/Invoice/CommonInvoiceAdd';

const PurchaseInvoiceAdd = () => {
    return (
        <CommonInvoiceAdd
            isSale={false}
            isPurchase={true}
            isRefund={false}
            pageName="Ön Muhasebe > Fiş / Faturalar > Alış Faturaları"
        />
    )
}

export default PurchaseInvoiceAdd;